import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

import MaterialItem from './MaterialItem'

export default class MaterialsGroup extends React.Component {

  static propTypes = {
    mode: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      expandedIndex: null
    }
  }

  getGroupHeader = () => {
    if (this.props.mode === 'date') {
      return moment(this.props.header).format('ddd, MMM DD, YYYY')
    }
    return this.props.header
  }

  onRowSelection = (expandedIndex) => {
    if (expandedIndex === this.state.expandedIndex){
      this.setState({ expandedIndex: null})
    } else {
      this.setState({ expandedIndex })
    }
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.groupHeader}>
          {this.getGroupHeader()}
        </div>
        <div style={styles.materials}>
          <div style={{ width: '100%' }}>
            <div style={styles.listHeaderContainer}>
              <div style={{ ...styles.iconHeader, ...styles.listSelectWidth }}></div>
              <div style={{ ...styles.listHeader, ...styles.listMainWidth }}>Item</div>
              <div style={{ ...styles.listHeader, ...styles.listMinorWidth }}>Quantity</div>
              <div style={{ ...styles.listHeader, ...styles.listMinorWidth }}>Cost (per unit)</div>
              <div style={{ ...styles.listHeader, ...styles.listMinorWidth }}>Cost (total)</div>
              <div style={{ ...styles.listHeader, ...styles.listMinorWidth }}>Used On</div>
            </div>
            {
              this.props.list && this.props.list
                .filter(material => !material.delete).map((material, index) =>
                  <MaterialItem
                    key={index}
                    index={index}
                    material={material}
                    expanded={this.state.expandedIndex === index}
                    onPress={this.onRowSelection.bind(this, index)} />)
            }
          </div>
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: 8
  },
  groupHeader: {
    color: '#000'
  },
  header: {
    color: '#757575',
    fontWeight: 500,
    fontSize: 14,
    paddingLeft: 14,
    paddingRight: 14
  },
  row: {
    borderBottom: '1px solid #527da3'
  },
  materials: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 4,
    flexWrap: 'wrap'
  },

  listHeader: {
    color: '#757575',
    fontWeight: 500,
    fontSize: 14,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 8
  },

  iconHeader: {
    paddingLeft: 16,
    paddingBottom: 8
  },

  listHeaderContainer: {
    display:'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #527da3'
  },

  listMainWidth: {
    width: 200
  },

  listMinorWidth: {
    width: 100
  },

  listSelectWidth: {
    width: 16
  }
}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/materials/MaterialsGroup.js